import React, { useState } from 'react';
import { useInterval } from '../../../hooks/useInterval.es.js';
import { DefaultCountdown } from './DefaultCountdown.es.js';

const calculateTimeDelta = (date) => {
    let startTimestamp;
    if (typeof date === 'string') {
        startTimestamp = new Date(date).getTime();
    }
    else if (date instanceof Date) {
        startTimestamp = date.getTime();
    }
    else {
        startTimestamp = date;
    }
    const durationInMs = Math.round(parseFloat((Math.max(0, startTimestamp - Date.now()) / 1000).toFixed(0)) *
        1000);
    const durationInSecond = durationInMs / 1000;
    return {
        durationInMs,
        days: Math.floor(durationInSecond / (3600 * 24)),
        hours: Math.floor((durationInSecond / 3600) % 24),
        minutes: Math.floor((durationInSecond / 60) % 60),
        seconds: Math.floor(durationInSecond % 60),
    };
};
const DefaultRenderer = (duration, size = 'md') => React.createElement(DefaultCountdown, { duration: duration, size: size });
const Countdown = ({ date, renderer = DefaultRenderer, className, size = 'md', }) => {
    const [duration, setDuration] = useState(calculateTimeDelta(date));
    useInterval(() => {
        setDuration(calculateTimeDelta(date));
    }, 1000, duration.durationInMs === 0);
    return (React.createElement("div", { className: className }, renderer && renderer(duration, size)));
};

export { Countdown, calculateTimeDelta };
